import { NOTIFICATION } from "../_constants/actionConstants";

const webSocketMiddleware = (store) => (next) => (action) => {
  if (action.signalR) {
    switch (action.type) {
      case NOTIFICATION.ADD_NOTIFICATION:
        break;
      default:
        break;
    }
  }
  next(action);
};

export default webSocketMiddleware;
